module.exports = __webpack_public_path__ + "static/media/will_smith.07c0aab8.jpg";